import { render, staticRenderFns } from "./prizeEventList.vue?vue&type=template&id=f16daef4&scoped=true&"
import script from "./prizeEventList.vue?vue&type=script&lang=js&"
export * from "./prizeEventList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f16daef4",
  null
  
)

export default component.exports